import { forwardRef } from 'react'

import { IconInfo } from '~/icons/info'

import { buttonLabel } from './constants/button-label'
import { Box } from '../box/box'
import { ButtonMinimalInternal } from '../button/button-minimal-internal'
import { IconButtonMinimalInternal } from '../icon-button/icon-button-minimal-internal'
import type { PopoverTriggerRenderProps } from '../popover/types'

export type Props = PopoverTriggerRenderProps & {
    ariaControls?: string
    ariaExpanded?: boolean
    label?: string
}

const stylesTriggerProxy = {
    width: 'fit-content',
    height: 'fit-content',
} as const

export const InfoTipTrigger = forwardRef<HTMLButtonElement, Props>(
    ({ ariaControls, ariaExpanded, disabled, onClick, label }, ref) => (
        <Box css={stylesTriggerProxy}>
            {label ? (
                <ButtonMinimalInternal
                    color="text"
                    aria-controls={ariaControls}
                    aria-expanded={ariaExpanded}
                    ref={ref}
                    onClick={(event) => {
                        event.stopPropagation()
                        onClick?.(event)
                    }}
                    prefix={<IconInfo />}
                    position="relative"
                >
                    {label}
                </ButtonMinimalInternal>
            ) : (
                <IconButtonMinimalInternal
                    color="text"
                    ref={ref}
                    size="small"
                    aria-controls={ariaControls}
                    aria-expanded={ariaExpanded}
                    aria-label={buttonLabel}
                    disabled={disabled}
                    isTooltipVisible={false}
                    icon={<IconInfo />}
                    onClick={(event) => {
                        event.stopPropagation()
                        onClick?.(event)
                    }}
                    label={buttonLabel}
                    position="relative"
                />
            )}
        </Box>
    ),
)

InfoTipTrigger.displayName = 'InfoTipTrigger'
